import React from 'react'
import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import Button from '@shared/ui/Actions/Button/Button'
import SwitchImg from '@images/ownerPersonalPage/Booking/switch.png'
import SwitchImg2x from '@images/ownerPersonalPage/Booking/switch-2x.png'
import s from './BookingUnavailable.module.sass'

const BookingUnavailable: React.FC = () => {
  return (
    <div className={s.container}>
      <div className={s.card}>
        <div className={s.content}>
          <div className={s.illustration}>
            <img srcSet={`${SwitchImg.src} 1x, ${SwitchImg2x.src} 2x`} alt='Бронирование нужно подключить' />
          </div>

          <div className={s.text}>
            <Title tag='h1' sizes='h2' className={s.title}>
              Бронирования нужно подключить
            </Title>

            <Text sizes='ML' className={s.description}>
              Чтобы начать принимать брони на столы на Афише Рестораны,
              <br />
              подключите тариф «ПРО» в разделе «Подписка»
              <br />
              или свяжитесь с нами restaurants@afisha.ru
            </Text>
          </div>

          <Button.Link
            href='https://www.afisha.ru/msk/restaurant/san-si-1600429/owner/#tab=ruble'
            sizes='XL'
            mode='black'>
            Подключить тариф «ПРО»
          </Button.Link>
        </div>
      </div>
    </div>
  )
}

export default BookingUnavailable
